import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import styled from 'styled-components'
import { HeaderSection } from 'app/components/Layouts'
import ModernOverviewBody from './ModernOverviewBody'
import { APPNAME } from 'app/constants/APIKEYS'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0;
  background: transparent;
`

export const AdminOverViewPage = () => {
	return (
		<StyledLayout>
			<Helmet>
				<title>{APPNAME} ADMIN DASHBOARD</title>
			</Helmet>
			<HeaderSection />
			<StyledContent>
				<ModernOverviewBody />
			</StyledContent>
		</StyledLayout>
	)
}
